import { render } from "./MergeSimilarCompanies.vue?vue&type=template&id=ee4a2ad6&scoped=true"
import script from "./MergeSimilarCompanies.vue?vue&type=script&lang=js"
export * from "./MergeSimilarCompanies.vue?vue&type=script&lang=js"

import "./MergeSimilarCompanies.vue?vue&type=style&index=0&id=ee4a2ad6&lang=sass&scoped=true"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee4a2ad6"]])

export default __exports__